import { PUBLIC_CONTROLLER } from '$env/static/public';
import { PUBLIC_AWAIT_USER } from '$env/static/public';
import { PUBLIC_DEBUG } from '$env/static/public';
import { PUBLIC_CUSTOM_CONTENT } from '$env/static/public';

export function load() {
	return {
		controller: PUBLIC_CONTROLLER,
		await_user: PUBLIC_AWAIT_USER,
		debug: PUBLIC_DEBUG,
		custom: PUBLIC_CUSTOM_CONTENT,
	}
}